import { __rest } from '../../../_virtual/_tslib.js';
import { useForkRef } from '@mui/material';
import { useRef, useEffect, useCallback } from 'react';

function useBaseInput({ inputProps, ref }) {
    const { inputRef, onClickIcon, onKeyDown, onFocus, onClick, setSelection } = inputProps, restProps = __rest(inputProps, ["inputRef", "onClickIcon", "onKeyDown", "onFocus", "onClick", "setSelection"]);
    const myRef = useRef(null);
    const containedRef = useForkRef(inputRef, ref);
    const baseInputRef = useForkRef(myRef, containedRef);
    const hasFocus = document.activeElement === myRef.current;
    useEffect(() => {
        if (hasFocus) {
            setSelection();
        }
    }, [hasFocus, setSelection]);
    const handleClickIcon = useCallback((event) => {
        event.stopPropagation();
        onClickIcon === null || onClickIcon === void 0 ? void 0 : onClickIcon();
    }, [onClickIcon]);
    const handleKeyDown = useCallback((event) => {
        if (["ArrowDown", "ArrowUp", "Backspace", "Delete", "Enter", "Escape", "Space", "Tab"].includes(event.key)) {
            onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
        }
        else {
            event.preventDefault();
        }
    }, [onKeyDown]);
    const handleFocus = useCallback((event) => {
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
        setSelection();
    }, [onFocus, setSelection]);
    const handleClick = useCallback((event) => {
        event.stopPropagation();
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
        setSelection();
    }, [onClick, setSelection]);
    return {
        baseInputProps: Object.assign(Object.assign({}, restProps), { onClear: undefined, onClick: handleClick, onFocus: handleFocus, onKeyDown: handleKeyDown }),
        handleClickIcon,
        baseInputRef,
    };
}

export { useBaseInput };
//# sourceMappingURL=useBaseInput.js.map
